import styled from "styled-components";

export const PageContainer = styled.div`
width: 100%;
height: auto;
min-height: 690px;
padding-bottom: 20px;
background: rgb(244,98,222);
background: linear-gradient(180deg, rgba(244,98,222,1) 16%, rgba(102,175,249,1) 51%, rgba(255,255,255,1) 100%);
color: white;
font-family: 'Anton', sans-serif;

@media (max-width:768px) {
font-size: 4vw;
}
`;

export const TitleBarContainer = styled.div`
width: 100%;
height: 5vw;
min-height: 15px;
display: flex;
justify-content: center;
align-items: center;
background-color:#4169e1 ;
color:white;

@media (max-width:768px) {
height: 10vw;
}
`;

export const TitleName = styled.span`
font-size: 2vw;
font-weight: 900;

@media (max-width:768px) {
font-size: 4vw;
}
`;

export const ContentContainer = styled.div`
height: auto;
width: 90%;
margin: 0 auto;
display: grid;
grid-template-columns: repeat(3, 1fr); 
gap: 20px; 
padding: 50px 0px;

@media (max-width:1282px) {
grid-template-columns: repeat(2, 1fr);
}

@media (max-width:838px) {
grid-template-columns: repeat(1, 1fr);
}
`;

export const SponsorshipContainer = styled.div`
width: 100%;
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
`;

export const SponsorshipCard = styled.div`
width: 380px;
height: 380px;
background-color: white;
border-radius:10px;
justify-content: center;
transition: transform 0.3s ease;

&:hover {
  transform: scale(1.2);
}

@media (max-width:1128px) {
background:none;
transition: none;

&:hover {
    transform: none;
}
}
`;

export const SponsorshipImg = styled.div`
width: 90%;
height: 75%;
margin: 30px auto;
border-radius: 10px;
background-repeat: no-repeat;
background-position: center;
background-size: cover;
background-color: white;

@media (max-width:1128px) {
transition: transform 0.3s ease;

&:hover {
    transform: scale(1.3);
}

@media (max-width:768px) {
height: auto;
min-height: 300px;
width: 60%;
min-width: 300px;
}
}
`;

export const SponsorshipName = styled.div`
width: 100%;
height: 5%;
display: flex;
justify-content: center;
align-items: center;
font-size: 20px;
color: black;
`;